<template>
  <section v-if="MeetingVisible" class="meeting-notice" aria-label="Canlı ders bildirimi">
    <div class="container meeting-notice__inner">
      <div class="meeting-notice__info">
        <span class="meeting-notice__icon" aria-hidden="true"><i class="bi bi-camera-video"></i></span>
        <div class="meeting-notice__copy" role="status">
          <strong>Dersin başladı.</strong>
          <span>Öğretmeninle buluşma zamanı.</span>
        </div>
      </div>
      <a v-if="MeetingType === 10" :href="MeetingUrl" class="meeting-notice__action" target="_blank" rel="noopener noreferrer" aria-label="Online derse katıl (yeni sekmede açılır)">
        Online derse katıl <i class="bi bi-arrow-up-right" aria-hidden="true"></i>
      </a>
      <router-link v-else to="/zoom-call" class="meeting-notice__action" target="_blank" rel="noopener noreferrer" aria-label="Online derse katıl (yeni sekmede açılır)">
        Online derse katıl <i class="bi bi-arrow-up-right" aria-hidden="true"></i>
      </router-link>
    </div>
  </section>
</template>

<script>
export default {
  name: 'NotificationForMeeting',
  data() {
    return { pollTimer: null, requestController: null, pollingActive: false };
  },
  computed: {
    MeetingUrl() { return this.$store.getters.MeetingUrl; },
    MeetingType() { return Number(this.$store.getters.MeetingType); },
    MeetingVisible() {
      return this.MeetingType === 99 || (this.MeetingType === 10 && !!this.MeetingUrl);
    },
  },
  methods: {
    async refreshMeeting() {
      if (!this.pollingActive) return;
      this.requestController = new AbortController();
      try {
        await this.$store.dispatch('AddMeetingUrl', { signal: this.requestController.signal });
      } catch {
        // Retry on the next poll without interrupting navigation.
      } finally {
        if (this.pollingActive) {
          this.pollTimer = window.setTimeout(() => this.refreshMeeting(), 15000);
        }
      }
    },
  },
  mounted() {
    // Verify persisted meeting data before showing an old invitation.
    this.$store.commit('SetMeetingUrl', { meetingUrl: '', meetingType: 0 });
    this.pollingActive = true;
    this.refreshMeeting();
  },
  beforeUnmount() {
    this.pollingActive = false;
    window.clearTimeout(this.pollTimer);
    this.requestController?.abort();
  },
};
</script>

<style scoped>
.meeting-notice {
  background: #087f65;
  border-bottom: 3px solid #06634f;
  box-shadow: 0 4px 12px rgba(6, 99, 79, 0.16);
  color: #fff;
}
.meeting-notice__inner {
  display: flex; align-items: center; justify-content: space-between;
  gap: 16px; padding-top: 16px; padding-bottom: 16px;
}
.meeting-notice__info { display: flex; align-items: center; gap: 12px; min-width: 0; }
.meeting-notice__icon {
  display: grid; place-items: center; width: 40px; height: 40px;
  flex-shrink: 0; border-radius: 12px; background: rgba(255, 255, 255, 0.16); color: #fff; font-size: 20px;
}
.meeting-notice__copy { display: flex; align-items: baseline; flex-wrap: wrap; column-gap: 12px; }
.meeting-notice__copy strong { font-size: 16px; font-weight: 700; }
.meeting-notice__copy span { color: #e2f4ed; font-size: 13px; }
.meeting-notice__action {
  display: inline-flex; align-items: center; justify-content: center;
  gap: 10px; flex-shrink: 0; min-height: 44px; padding: 10px 18px;
  border-radius: 10px; background: #fff; color: #06634f;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  font-size: 14px; font-weight: 700; text-decoration: none;
  transition: background-color 150ms ease;
}
.meeting-notice__action:hover { background: #e2f4ed; color: #064f40; }
.meeting-notice__action:focus-visible { outline: 3px solid #fff; outline-offset: 4px; }
@media (max-width: 575px) {
  .meeting-notice__inner { gap: 10px; }
  .meeting-notice__icon { display: none; }
  .meeting-notice__copy { flex-direction: column; gap: 2px; }
  .meeting-notice__copy span { font-size: 12px; }
  .meeting-notice__action { padding: 10px 12px; }
}
@media (prefers-reduced-motion: reduce) {
  .meeting-notice__action { transition: none; }
}
</style>
